import React, { FC, ReactNode, useState } from 'react';
import { LetsGetStartedContext } from './context';
import {
  CompanyInfoFormDataType,
  CreatePasswordFormDataType,
  PersonalInfoFormDataType
} from 'models/get-started.model';

const LetsGetStartedProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [personalInfoFormData, setPersonalInfoFormData] = useState<PersonalInfoFormDataType>({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: ''
  });
  const [companyInfoFormData, setCompanyInfoFormData] = useState<CompanyInfoFormDataType>({
    company_name: '',
    company_email: '',
    company_address: '',
    cac_number: '',
    company_logo: ''
  });

  const [passwordFormData, setPasswordFormData] = useState<CreatePasswordFormDataType>({
    password: '',
    confirm_password: ''
  });
  const [disabled, setDisabled] = useState<boolean>(true);

  return (
    <LetsGetStartedContext.Provider
      value={{
        personalInfoFormData,
        setPersonalInfoFormData,
        companyInfoFormData,
        setCompanyInfoFormData,
        passwordFormData,
        setPasswordFormData,
        disabled,
        setDisabled
      }}>
      {children}
    </LetsGetStartedContext.Provider>
  );
};

export default LetsGetStartedProvider;
